import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Edit from 'shared/ui/icons/General/Edit';
import {DeleteButton, EditButton} from 'shared/ui/IconButton/iconButtons';

import styles from './NotifyChannels.module.scss';

interface IDescriptionCellProps {
    description: string,
    placeholder: string,
    onEdit?: () => void,
}

export const DescriptionCell: React.FC<IDescriptionCellProps> = ({description, placeholder, onEdit}) => (
    <td>
        <div className={styles.descriptionBlock}>
            <span>
                {description.length > 0
                    ? <span className={styles.contentColor}>{description}</span>
                    : placeholder
                }
            </span>
            {onEdit && <span onClick={onEdit}><Edit/></span>}
        </div>
    </td>
);

interface IActionCellsProps {
    onEdit?: () => void,
    onDelete?: () => void,
}

export const ActionCells: React.FC<IActionCellsProps> = ({onEdit, onDelete}) => (
    <>
        <td>
            {onEdit && (
                <EditButton
                    iconSize={16}
                    onClick={onEdit}
                    title={t`Изменить`}
                    className={cn(styles.icon, styles.iconEdit)}
                />
            )}
        </td>
        <td>
            {onDelete && (
                <DeleteButton
                    iconSize={16}
                    onClick={onDelete}
                    title={t`Удалить`}
                    className={cn(styles.icon, styles.iconDelete)}
                />
            )}
        </td>
    </>
);
